import {connect} from 'react-redux';
import Footer from 'app/components/Footer/Footer';

export const mapStateToProps = () => {
    return {};
};

export const mapDispatchToProps = () => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);

